module.exports = __webpack_public_path__ + "img/availableColors.b121441.webp";